import type { TableMapDto as TableMapDtoV2 } from '@ordr-as/ordr-service-types/epos';
import {
  useBulkUpdateTableMapsV2,
  useGetTableMapByIdV2,
  useGetTableMapsSummaryV2,
  useGetTableMapsV2,
} from '@ordr-as/ordr-service-types/epos';

export const useQueryGetTableMap = (locationId: number, zoneId?: number, tableMapId?: string, enabled = true) => {
  const { queryKey: _queryKey, ...result } = useGetTableMapByIdV2(locationId, zoneId ?? 0, tableMapId ?? '', {
    query: {
      enabled: enabled && Boolean(locationId) && Boolean(zoneId) && Boolean(tableMapId),
      staleTime: 1000 * 60 * 5,
    },
  });
  return result;
};

export const useQueryGetTableMaps = (locationId: number, zoneId: number) => {
  const { queryKey: _queryKey, ...result } = useGetTableMapsV2(locationId, zoneId, undefined, {
    query: {
      enabled: Boolean(locationId) && Boolean(zoneId),
    },
  });
  return result;
};

export const useQueryGetTableMapSummary = (
  locationId: number,
  zoneId?: number,
  activeOnly?: boolean,
  excludeEmptyMaps?: boolean
) => {
  const { queryKey: _queryKey, ...result } = useGetTableMapsSummaryV2(
    locationId,
    zoneId ?? 0,
    { active: activeOnly, excludeEmptyMaps },
    {
      query: {
        enabled: Boolean(locationId) && Boolean(zoneId),
        staleTime: 1000 * 60 * 5,
      },
    }
  );
  return result;
};

export const useMutateBulkUpdateTableMaps = (locationId: number, zoneId: number) => {
  const { mutate, mutateAsync, ...rest } = useBulkUpdateTableMapsV2();

  return {
    ...rest,
    mutate: (tableMaps: TableMapDtoV2[], options?: Parameters<typeof mutate>[1]) =>
      mutate({ data: { tableMaps }, locationId, zoneId }, options),
    mutateAsync: (tableMaps: TableMapDtoV2[], options?: Parameters<typeof mutateAsync>[1]) =>
      mutateAsync({ data: { tableMaps }, locationId, zoneId }, options),
  };
};
